import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import { EVENT_COLORS } from "@/config";
import { fabMixin } from "@/styles/mixins";

const buttonMixin = css`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: var(--size);
  height: var(--size);
  padding: 0;
  outline: none;
  background-color: var(--color);
`;

export const AddTaskButtonWrap = styled.div`
  ${fabMixin}
`;

export const SubButton = motion(styled.button`
  --size: 40px;
  --btn-pad: 5px;
  ${buttonMixin};
  position: absolute;
  width: var(--size);
  height: var(--size);
  top: 1px;
  left: var(--btn-pad);
  z-index: 1;
`);

export const MainButton = motion(styled.button`
  --size: 50px;
  --btn-pad: 0px;
  --color: ${EVENT_COLORS.business};
  ${buttonMixin};
  z-index: 2;
  position: relative;
  box-shadow: 0px 6px 26px -5px ${({ theme }) => theme.color.positive};
  span {
    line-height: 0;
  }
`);

export const Backdrop = motion(styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 11;
`);

export const EventName = motion(styled.div`
  --pad: calc(60px - var(--btn-pad));
  background: var(--color);
  color: white;
  font-weight: 500;
  border-radius: var(--root-br);
  padding: 7px 10px;
  position: absolute;
  font-size: 14px;
  right: var(--pad);
  white-space: nowrap;
`);
